import {
  FormControl,
  FormItem,
  FormMessage
} from "@watt/ui/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@watt/ui/components/ui/select";
import type * as z from "zod";
import AutoFormLabel from "../common/label";
import AutoFormTooltip from "../common/tooltip";
import type { AutoFormInputComponentProps } from "../utils/types";
import { getBaseSchema } from "../utils/utils";

export default function AutoFormEnum({
  label,
  isRequired,
  field,
  fieldConfigItem,
  zodItem,
  fieldProps
}: AutoFormInputComponentProps) {
  // biome-ignore lint/suspicious/noExplicitAny: <fix later>
  const baseValues = (getBaseSchema(zodItem) as unknown as z.ZodEnum<any>)._def
    .values;

  let values: [string, string][] = [];
  if (!Array.isArray(baseValues)) {
    values = Object.entries(baseValues);
  } else {
    values = baseValues.map(value => [value, value]);
  }

  // biome-ignore lint/suspicious/noExplicitAny: <fix later>
  function findItem(value: any) {
    return values.find(item => item[0] === value);
  }

  return (
    <FormItem>
      <AutoFormLabel
        isRequired={isRequired}
        label={fieldConfigItem?.label || label}
      />
      <FormControl>
        <Select
          defaultValue={field.value}
          onValueChange={field.onChange}
          {...fieldProps}
        >
          <SelectTrigger className={fieldProps.className}>
            <SelectValue placeholder={fieldConfigItem.inputProps?.placeholder}>
              {field.value ? findItem(field.value)?.[1] : "Select an option"}
            </SelectValue>
          </SelectTrigger>
          <SelectContent>
            {values.map(([value, label]) => (
              <SelectItem key={value} value={label}>
                {label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </FormControl>
      <AutoFormTooltip fieldConfigItem={fieldConfigItem} />
      <FormMessage />
    </FormItem>
  );
}
